import { Injectable } from '@angular/core';
import { ApiResponseNotificationListFrontend, USER_URL } from '../shared/src';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ErrorHandlerService } from './error-handler.service';
import { catchError, Observable, tap, throwError } from 'rxjs';
import { ApiResponseNotificationList } from '../shared/src';


@Injectable({
    providedIn: 'root',
  })

 export class NotificationService{
    private readonly NOTIFICATION_URL = `${USER_URL}/notification`;
    constructor(
        private http: HttpClient,
        private errorHandler: ErrorHandlerService
      ) { }

      public getAllNotification(
        limit?: number
      ): Observable<ApiResponseNotificationListFrontend> {
        // Construct HttpParams with optional values
        let params = new HttpParams();
        if (limit !== undefined) {
          params = params.set('limit', limit.toString());
        }
    
        return this.http.get<ApiResponseNotificationListFrontend>(
          `${this.NOTIFICATION_URL}/getAll`, { params }
        ).pipe(catchError(this.errorHandler.handleError));
      }
      

      public markAsRead(id?: number): Observable<void> {
        // If id is not provided, send an empty object
        const body = id ? { id } : {};
        return this.http
          .put<void>(`${this.NOTIFICATION_URL}/markAsRead`, body)
          .pipe(catchError(this.errorHandler.handleError));
      }
      
  
 }
